<template>
  <div class="faq background">
    <img
      srcset="
        /frontend/assets/img/about/flower6.webp,
        /frontend/assets/img/about/flower6@2x.webp 2x
      "
      src="/frontend/assets/img/about/flower6.webp"
      alt="цветок"
      class="faq__flower"
    />
    <img
      srcset="
        /frontend/assets/img/product-flower1.webp,
        /frontend/assets/img/product-flower1@2x.webp 2x
      "
      src="/frontend/assets/img/product-flower1.webp"
      alt="Flower"
      class="faq__flower2"
    />
    <img
      srcset="
        /frontend/assets/img/articles-slider__art_2.webp,
        /frontend/assets/img/articles-slider__art_2@2x.webp 2x
      "
      src="/frontend/assets/img/articles-slider__art_2.webp"
      alt="ягода"
      class="faq__flower3"
    />
    <!-- <img
      srcset="
        /frontend/assets/img/about/flower.webp,
        /frontend/assets/img/about/flower@2x.webp 2x
      "
      src="/frontend/assets/img/about/flower.webp"
      alt="цветок"
      class="faq__flower4"
    /> -->
    <!-- <img
      srcset="
        /frontend/assets/img/faq/flower.webp,
        /frontend/assets/img/faq/flower@2x.webp 2x
      "
      src="/frontend/assets/img/faq/flower.webp"
      alt="цветок"
      class="faq__flower5"
    /> -->
    <picture class="faq__agu">
      <source
        srcset="
          /frontend/assets/img/faq/agu-boy2.webp,
          /frontend/assets/img/faq/agu-boy2@2x.webp 2x
        "
        media="(min-width: 1920px)"
      />
      <source
        srcset="
          /frontend/assets/img/faq/agu-boy2.webp,
          /frontend/assets/img/faq/agu-boy2@2x.webp 2x
        "
        media="(min-width: 1024px)"
      />
      <source
        srcset="
          /frontend/assets/img/faq/agu-boy2.webp,
          /frontend/assets/img/faq/agu-boy2@2x.webp 2x
        "
        media="(min-width: 768px)"
      />
      <img
        srcset="
          /frontend/assets/img/faq/agu-boy3.webp,
          /frontend/assets/img/faq/agu-boy3@2x.webp 2x
        "
        src="/frontend/assets/img/faq/agu-boy3.webp"
        alt="Agu boy"
      />
    </picture>
    <picture class="background__header">
      <source
        srcset="
          /frontend/assets/img/main/header1920-2.webp,
          /frontend/assets/img/main/header1920-2@2x.webp 2x
        "
        media="(min-width: 1920px)"
      />
      <source
        srcset="
          /frontend/assets/img/main/header1920-2.webp,
          /frontend/assets/img/main/header1920-2@2x.webp 2x
        "
        media="(min-width: 1024px)"
      />
      <source
        srcset="
          /frontend/assets/img/main/header1024-2.webp,
          /frontend/assets/img/main/header1024-2@2x.webp 2x
        "
        media="(min-width: 768px)"
      />
      <img
        srcset="
          /frontend/assets/img/main/header375-2.webp,
          /frontend/assets/img/main/header375-2@2x.webp 2x
        "
        src="/frontend/assets/img/main/header375-2.webp"
        alt="фон страницы"
      />
    </picture>
    <html-bg />
    <!-- <picture class="background__middle">
      <source
        srcset="
          /frontend/assets/img/main/middle-2-1920.webp,
          /frontend/assets/img/main/middle-2-1920@2x.webp 2x
        "
        media="(min-width: 1920px)"
      />
      <source
        srcset="
          /frontend/assets/img/main/middle-2-1920.webp,
          /frontend/assets/img/main/middle-2-1920@2x.webp 2x
        "
        media="(min-width: 1024px)"
      />
      <source
        srcset="
          /frontend/assets/img/main/middle-2-1024.webp,
          /frontend/assets/img/main/middle-2-1024@2x.webp 2x
        "
        media="(min-width: 768px)"
      />
      <img
        srcset="
          /frontend/assets/img/main/middle-2-1024.webp,
          /frontend/assets/img/main/middle-2-1024@2x.webp 2x
        "
        src="/frontend/assets/img/main/middle-2-1024.webp"
        alt="фон страницы"
      />
    </picture> -->
    <!-- <picture class="background__middle2">
      <source
        srcset="
          /frontend/assets/img/main/middle1920.webp,
          /frontend/assets/img/main/middle1920@2x.webp 2x
        "
        media="(min-width: 1920px)"
      />
      <source
        srcset="
          /frontend/assets/img/main/middle1366.webp,
          /frontend/assets/img/main/middle1366@2x.webp 2x
        "
        media="(min-width: 1024px)"
      />
      <source
        srcset="
          /frontend/assets/img/main/middle1024.webp,
          /frontend/assets/img/main/middle1024@2x.webp 2x
        "
        media="(min-width: 768px)"
      />
      <img
        srcset="
          /frontend/assets/img/main/middle1024.webp,
          /frontend/assets/img/main/middle1024@2x.webp 2x
        "
        src="/frontend/assets/img/main/middle1024.webp"
        alt="фон страницы"
      />
    </picture> -->
    <picture class="background__footer">
      <source
        srcset="
          /frontend/assets/img/main/footer1920.webp,
          /frontend/assets/img/main/footer1920@2x.webp 2x
        "
        media="(min-width: 1920px)"
      />
      <source
        srcset="
          /frontend/assets/img/main/footer1920.webp,
          /frontend/assets/img/main/footer1920@2x.webp 2x
        "
        media="(min-width: 1024px)"
      />
      <source
        srcset="
          /frontend/assets/img/main/footer1024.webp,
          /frontend/assets/img/main/footer1024@2x.webp 2x
        "
        media="(min-width: 768px)"
      />
      <img
        srcset="
          /frontend/assets/img/main/footer375.webp,
          /frontend/assets/img/main/footer375@2x.webp 2x
        "
        src="/frontend/assets/img/main/footer375.webp"
        alt="фон страницы"
      />
    </picture>
    <div class="holder holder--full">
      <h1 class="faq__title">Вопросы и ответы об Агуше</h1>
      <div class="faq__wrapper">
        <div class="faq__back-header">
          <svg
            preserveAspectRatio="none"
            viewBox="0 0 1570 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M273.002 15.9126C402.002 40.5239 424.168 2.7184 570.002 2.7184C698.814 2.7184 766.154 57.5831 850.502 56.9611C929.607 56.3776 996.895 2.7184 1076 2.7184C1171.37 2.7184 1286.5 67.1461 1352.5 41.6836C1418.5 16.2212 1570 -3 1570 120H0C0 -23.67 144.002 -8.69875 273.002 15.9126Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="faq__back-footer">
          <svg
            preserveAspectRatio="none"
            viewBox="0 0 1570 153"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1658_15455)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1297 104.478C1168 79.8667 1145.83 117.672 999.998 117.672C871.186 117.672 803.846 62.8075 719.498 63.4295C640.393 64.0131 573.105 117.672 493.998 117.672C398.634 117.672 283.502 53.2445 217.502 78.707C151.502 104.169 0 123.391 0 0.390625H1570C1570 144.061 1426 129.089 1297 104.478Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_1658_15455">
                <rect
                  width="1570"
                  height="152"
                  fill="white"
                  transform="translate(0 0.390625)"
                />
              </clipPath>
            </defs>
          </svg>
          <svg
            preserveAspectRatio="none"
            viewBox="0 0 375 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M152.781 12.3641C233.16 18.6491 295.833 48.3725 375 27.9161V-0.472973L0 -0.472973V27.9165C17.1412 23.4999 66.1074 2.24343 138.426 10.9341C143.205 11.51 147.991 11.9867 152.781 12.3641Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="faq__back-left"></div>
        <div class="faq__back-right"></div>
        <div class="faq__holder">
          <div class="faq__side">
            <div class="faq-side">
              <img
                srcset="
                  /frontend/assets/img/faq/flower2.webp,
                  /frontend/assets/img/faq/flower2@2x.webp 2x
                "
                src="/frontend/assets/img/faq/flower2.webp"
                alt="цветок"
                class="faq__flower6"
              />
              <img
                srcset="
                  /frontend/assets/img/faq/qst.webp,
                  /frontend/assets/img/faq/qst@2x.webp 2x
                "
                src="/frontend/assets/img/faq/qst.webp"
                alt="цветок"
                class="faq__qst"
              />
              <picture class="faq__agu faq__agu--mobile">
                <source
                  srcset="
                    /frontend/assets/img/faq/agu-boy2.webp,
                    /frontend/assets/img/faq/agu-boy2@2x.webp 2x
                  "
                  media="(min-width: 1920px)"
                />
                <source
                  srcset="
                    /frontend/assets/img/faq/agu-boy2.webp,
                    /frontend/assets/img/faq/agu-boy2@2x.webp 2x
                  "
                  media="(min-width: 1024px)"
                />
                <source
                  srcset="
                    /frontend/assets/img/faq/agu-boy2.webp,
                    /frontend/assets/img/faq/agu-boy2@2x.webp 2x
                  "
                  media="(min-width: 768px)"
                />
                <img
                  srcset="
                    /frontend/assets/img/faq/agu-boy3.webp,
                    /frontend/assets/img/faq/agu-boy3@2x.webp 2x
                  "
                  src="/frontend/assets/img/faq/agu-boy3.webp"
                  alt="Agu boy"
                />
              </picture>
              <svg
                class="faq-side__back"
                preserveAspectRatio="none"
                viewBox="0 0 384 488"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M35.2052 0C100.743 0 121.793 8.40978 174.194 8.40978C226.594 8.40978 277.049 0 348.432 0C367.794 0 382.971 15.9542 383.637 35.4248C385.899 101.515 376.851 122.085 376.851 191.649C376.851 261.214 383.637 364.538 383.637 452.575C383.637 472.058 367.794 488 348.432 488C306.782 488 285.327 478.44 233.01 478.44C180.694 478.44 108.522 488 35.2052 488C15.843 488 0 472.059 0 452.575C0 371.21 7.69081 351.399 7.69081 281.784C7.69081 212.168 0 134.701 0 35.4248C0 15.9413 15.8433 0 35.2052 0Z"
                  fill="#F2FAFF"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M35.2052 0C100.743 0 121.793 8.40978 174.194 8.40978C226.594 8.40978 277.049 0 348.432 0C367.794 0 382.971 15.9542 383.637 35.4248C385.899 101.515 376.851 122.085 376.851 191.649C376.851 261.214 383.637 364.538 383.637 452.575C383.637 472.058 367.794 488 348.432 488C306.782 488 285.327 478.44 233.01 478.44C180.694 478.44 108.522 488 35.2052 488C15.843 488 0 472.059 0 452.575C0 371.21 7.69081 351.399 7.69081 281.784C7.69081 212.168 0 134.701 0 35.4248C0 15.9413 15.8433 0 35.2052 0Z"
                  fill="url(#pattern0)"
                />
                <defs>
                  <pattern
                    id="pattern0"
                    patternContentUnits="objectBoundingBox"
                    width="0.416667"
                    height="0.327869"
                  >
                    <use
                      xlink:href="#image0_1609_11489"
                      transform="scale(0.00260417 0.00204918)"
                    />
                  </pattern>
                  <image
                    id="image0_1609_11489"
                    width="160"
                    height="160"
                    xlink:href="data:image/png;base64,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"
                  />
                </defs>
              </svg>
              <svg
                class="faq-side__back-mask"
                preserveAspectRatio="none"
                viewBox="0 0 384 488"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M35.2052 0H0V35.4248V452.575V488H35.2052H348.432H384V55.9802C383.996 80.0872 382.382 97.9621 380.689 116.714C378.818 137.428 376.851 159.213 376.851 191.649C376.851 224.386 378.354 264.598 379.945 307.175C381.735 355.074 383.637 405.967 383.637 452.575C383.637 472.058 367.794 488 348.432 488C328.792 488 313.644 485.875 297.632 483.628C279.687 481.11 260.658 478.44 233.01 478.44C209.054 478.44 180.934 480.445 150.447 482.618C114.356 485.191 74.949 488 35.2052 488C15.843 488 0 472.059 0 452.575C0 410.307 2.0755 384.65 4.07007 359.993C5.91504 337.186 7.6908 315.235 7.6908 281.784C7.6908 250.056 6.09338 216.698 4.35455 180.388C2.27808 137.027 0 89.4556 0 35.4248C0 15.9413 15.8433 0 35.2052 0ZM348.432 0C309.987 0 277.613 2.4393 247.736 4.69043C222.138 6.61917 198.373 8.40979 174.194 8.40979C149.457 8.40979 131.707 6.53571 112.965 4.55692C92.0051 2.34393 69.8047 0 35.2052 0H348.432ZM384 55.8174C383.999 49.4917 383.887 42.7368 383.637 35.4248C382.971 15.9542 367.794 0 348.432 0H384V55.8174Z"
                  fill="#fff"
                />
              </svg>

              <div class="faq-side__title">Выберите тему</div>
              <ul>
                <li
                  v-for="item of items"
                  :key="item.id"
                  :class="[{ _current: item.id === currentLink }]"
                >
                  <a :href="`#${item.id}`">
                  <!-- @click="chooseChapter($event, item.id)" -->
                    {{ item.title }}
                  </a>
                </li>
              </ul>
              <img
                srcset="
                  /frontend/assets/img/faq/agu-boy.webp,
                  /frontend/assets/img/faq/agu-boy@2x.webp 2x
                "
                src="/frontend/assets/img/faq/agu-boy.webp"
                alt="Agu"
                class="faq-side__agu"
              />
              <img
                srcset="
                  /frontend/assets/img/faq/agu-hands.webp,
                  /frontend/assets/img/faq/agu-hands@2x.webp 2x
                "
                src="/frontend/assets/img/faq/agu-hands.webp"
                alt="Agu"
                class="faq-side__agu-hands"
              />
            </div>
          </div>
          <div class="faq__main">
            <svg
              class="faq__main-header"
              preserveAspectRatio="none"
              viewBox="0 0 375 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M222.219 22.6359C141.84 16.3509 79.1667 -13.3725 0 7.08391L0 35.473L375 35.473V7.08352C357.859 11.5001 308.893 32.7566 236.574 24.0659C231.795 23.49 227.009 23.0133 222.219 22.6359Z"
                fill="white"
              />
            </svg>
            <ul class="faq__items">
              <li v-for="item of items" :key="item.id">
                <FaqItem
                  :item="item"
                  :selected="isActive(item)"
                  @toggle="toggleQuestion(item)"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FaqItem from "./FaqItem";
import HtmlBg from "./HtmlBg";

export default {
  name: "Faq",

  components: {
    FaqItem,
    HtmlBg,
  },

  props: {
    items: { type: Array, default: () => [] },
  },

  data() {
    return {
      currentQuestion: null,
      currentLink: "",
    };
  },

  computed: {
    isTablet() {
      return this.$vssWidth < 1024;
    },
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    toggleQuestion(question) {
      const sameClicked =
        this.currentQuestion && this.currentQuestion.id === question.id;
      this.currentQuestion = sameClicked ? null : question;
    },

    isActive(item) {
      return this.currentQuestion && this.currentQuestion.id === item.id;
    },

    chooseChapter(e, id) {
      if (this.isTablet) {
        e.preventDefault();
        const el = document.getElementById(id);
        el.classList.remove("_current");

        window.scrollTo(0, el.offsetTop);
      }
    },

    handleScroll() {
      this.items.map((obj) => {
        const el = document.getElementById(obj.id);
        if (el && this.isInViewport(el)) {
          this.currentLink = obj.id;
        }
      });
    },
    isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= 200 &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    },
  },
};
</script>
